import { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

import SearchParams from "simplydo/core/searchParams";
import { Button, ButtonLink } from "simplydo/react/ui/button";
import { Divider } from "simplydo/react/ui/divider";
import { H1 } from "simplydo/react/ui/header";
import { Message } from "simplydo/react/ui/message";

const LoginError = () => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const params = new SearchParams(window.location.search);
    setErrorMessage(params.get("message") || "");
  }, []);

  return (
    <div>
      <H1>{t("entry.login.title")}</H1>
      <Divider />
      <p>{t("entry.login.error.info")}</p>
      {errorMessage && <Message color="orange">{errorMessage}.</Message>}
      <ButtonLink style={{ float: "right" }} color="primary" to="/">
        {t("generic.close")}
      </ButtonLink>
    </div>
  );
};

export default LoginError;
